module.exports = __webpack_public_path__ + "static/media/facebook.79fe8037.svg";